<template>
  <div>
  <ClientHeader :cid="cid" :sid="sid"/>
<section class="client-end">
  <div class="container">
    <img src="../assets/img/mail-big.jpg" alt="mail-img" class="client-end__img">
    <p class="client-end__text">Запись успешно создана</p>
    <!-- <p class="client-end__text">На Ваш телефон придет уведомление с подробной информацией о записи</p> -->
    <!--<div id="divAdSenseInner" v-html="adsenseContent"></div>-->
    <adsense
        key="qwe_index_123"
        adClient="ca-pub-3132918828120911"
        adSlot="4253071633"
        adFormat="fluid"
        adStyle="display:block;min-width:251px;max-width:300px;width:100%;height:300px;margin: 0 auto;"
    ></adsense>
    <!--<form action="#"><input type="email" class="client-end__input" placeholder="Ваш E-mail"><button class="client-end__submit" type="button">Подписаться на рассылку</button></form>-->
  </div>
</section>
</div>
</template>
<script>
import ClientHeader from '@/components/ClientHeader.vue'
import Adsense from '@/components/ADSENSE/Adsense.vue'
export default {
  name: 'client-end',
  props: ["cid","sid"],
  data() {
    return {
      adsenseContent: ''
    }
  },
  components: {
    ClientHeader,
    Adsense
  },
  mounted() {
    // this.adsenseContent = document.getElementById('divAdSense-final').innerHTML;
  }
}
</script>
<style lang="sass">
// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content
// LAYOUT
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out

.client-end
  .container
    padding-top: 10%
    display: -ms-flexbox
    display: -webkit-flex
    display: flex
    -webkit-flex-direction: column
    -ms-flex-direction: column
    flex-direction: column
    -webkit-flex-wrap: nowrap
    -ms-flex-wrap: nowrap
    flex-wrap: nowrap
    -webkit-justify-content: center
    -ms-flex-pack: center
    justify-content: center
    -webkit-align-content: stretch
    -ms-flex-line-pack: stretch
    align-content: stretch
    -webkit-align-items: stretch
    -ms-flex-align: stretch
    align-items: stretch
  &__img
    display: block
    margin-left: auto
    margin-right: auto
    width: 100%
    height: auto
    max-width: 480px
    margin-bottom: 25px
  &__text
    text-align: center
    margin-top: 0
    margin-bottom: 15px
    font-size: 16px
    font-weight: 400
    line-height: 20px
    color: $text-36
    margin-left: auto
    margin-right: auto
    max-width: 310px
  form
    display: block
    width: 100%
  &__input
    display: block
    width: 100%
    margin-bottom: 20px
    max-width: 280px
    color: $text-36
    padding: 10px 20px
    font-size: 16px
    border-radius: 20px
    margin-left: auto
    margin-right: auto
    background-color: #F1F1F1
    border: 0
    box-shadow: none
  &__submit
    display: block
    width: 100%
    max-width: 280px
    margin-left: auto
    margin-right: auto
    text-align: center
    color: #fff
    background-color: $text-36
    border-radius: 20px
    padding: 10px 20px
    font-weight: 500
    border: 1px solid transparent
    box-shadow: none
    transition: all $transitSpeed
    &:hover
      cursor: pointer
      border-color: $text-36
      color: $text-36
      background-color: #fff
+r($mobile)
  .client-end
    box-shadow: 0 0 10px rgba(0,0,0,0.1)
    border-radius: 14px

@media only screen and (max-height: 550px)
  .client-end
    .container
      padding-top: 30px
    &__img
      width: 200px
</style>
